import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import DefaultUser from "../../Asserts/Images/govardhanimg.png";
import Instance from "../../AxiosConfig";

const Account = () => {
  const [form] = Form.useForm();
  const fileInputRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(DefaultUser);
  const [profileFile, setProfileFile] = useState(null);
  const [profileData, setProfileData] = useState([]);

  const handleProfileData = async () => {
    const storedData = localStorage.getItem("userData");
    console.log("storedData", storedData);

    if (!storedData) {
      message.error("User data not found in local storage.");
      return;
    }

    const parsedData = JSON.parse(storedData);
    const token = parsedData?.token;
    const userId = parsedData?.id;

    if (!userId) {
      message.error("User ID not found in local storage.");
      return;
    }

    try {
      const response = await Instance.get(`/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response:", response.data);

      if (response.status === 200 || response.status === 201) {
        const user =
          response.data?.user || response.data?.data || response.data;
        setProfileData(user);
        console.log("User Data Loaded into Form:", user);

        if (user.profilePhoto || user.avatar || user.imageUrl) {
          const imageUrl = user.profilePhoto || user.avatar || user.imageUrl;
          setPreviewImage(imageUrl);

          console.log("✅ Profile image found:", imageUrl);
          localStorage.setItem("profileImage", imageUrl);
        } else {
          console.log("⚠️ No profile image found in API response:", user);
        }

        form.setFieldsValue({
          name: user.userName || user.name || "",
          email: user.userEmail || user.email || "",
          phoneNumber: user.userPhoneNumber || user.phone || "",
        });
      }
    } catch (error) {
      console.error(
        "Error fetching profile data:",
        error.response || error.message
      );
    }
  };

  const handleUpdateProfileData = async () => {
    const storedData = localStorage.getItem("userData");
    if (!storedData) {
      message.error("User data not found in local storage.");
      return;
    }

    const parsedData = JSON.parse(storedData);
    const token = parsedData?.token;
    const userId = parsedData?.id;

    try {
      const values = await form.validateFields();

      const formData = new FormData();
      formData.append("userName", values.name);
      formData.append("userPhoneNumber", values.phoneNumber);

      if (profileFile) formData.append("profilePhoto", profileFile);
      console.log("🔹 User ID:", userId);
      console.log("🔹 Token:", token);
      console.log("🔹 Form values:", values);
      console.log("🔹 Profile file:", profileFile);

      for (let [key, value] of formData.entries()) {
        console.log(`➡️ ${key}:`, value);
      }

      const response = await Instance.put(
        `/profile/update/${userId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log("response", response);
        message.success("Profile updated successfully!");

        const updatedUser =
          response.data?.user || response.data?.data || response.data;
        if (
          updatedUser?.profilePhoto ||
          updatedUser?.avatar ||
          updatedUser?.imageUrl
        ) {
          const newImage =
            updatedUser.profilePhoto ||
            updatedUser.avatar ||
            updatedUser.imageUrl;
          localStorage.setItem("profileImage", newImage);
          setPreviewImage(newImage);
        }

        form.setFieldsValue({
          name: values.name,
          email: values.email,
          phoneNumber: values.phoneNumber,
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error.response || error.message);
      message.error("Failed to update profile");
    }
  };

  useEffect(() => {
    handleProfileData();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileFile(file);
      setPreviewImage(URL.createObjectURL(file));
      message.success("Profile image updated.");
    }
  };

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  // ❌ Reset to default
  const handleDeleteProfile = () => {
    setPreviewImage(DefaultUser);
    setProfileFile(null);
    message.info("Profile image Removed successfully.");
  };

  // 💾 Save form (local only)
  // const handleSubmit = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     console.log("Saved Data:", values);
  //     console.log("Profile File:", profileFile);

  //     message.loading({ content: "Saving...", key: "saving" });
  //     setTimeout(() => {
  //       message.success({
  //         content: "Profile saved successfully!",
  //         key: "saving",
  //       });
  //     }, 800);
  //   } catch (error) {
  //     message.error("Please fill all required fields correctly.");
  //   }
  // };

  return (
    <div className="settings-personal-information">
      <div className="container">
        <h4 className="mt-4 mt-lg-0">Account</h4>
        <hr style={{ color: "var(--black-color)" }} />

        <Form layout="vertical" form={form}>
          <h5>My Profile</h5>

          {/* 👤 Profile Image Section */}
          <div className="row mt-4">
            <div className="settings-profile-icon-section">
              <img
                src={previewImage}
                alt="Profile"
                className="settings-profile-image"
              />
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="image/*"
              />
              <button
                type="button"
                className="settings-edit-icon-button ms-3"
                onClick={handleEditClick}
              >
                Upload new
              </button>
              <button
                type="button"
                className="settings-delete-button ms-3"
                onClick={handleDeleteProfile}
              >
                Delete
              </button>
            </div>
          </div>

          {/* 🧾 Form Fields */}
          <div className="row mt-4">
            <div className="col-md-6 mt-4">
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  { required: true, message: "Name is required" },
                  { min: 3, message: "Name must be at least 3 characters" },
                ]}
              >
                <Input
                  className="settings-input"
                  placeholder="Enter your name"
                />
              </Form.Item>
            </div>

            <div className="col-md-6 mt-4">
              <Form.Item
                label="Phone Number"
                name="phoneNumber"
                rules={[
                  { required: true, message: "Phone number is required" },
                  {
                    pattern: /^[+0-9][0-9\s-]{9,14}$/,
                    message: "Enter a valid phone number",
                  },
                ]}
              >
                <Input
                  className="settings-input"
                  placeholder="Enter your phone number"
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mt-2">
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Email is required" },
                  { type: "email", message: "Enter a valid email address" },
                ]}
              >
                <Input
                  className="settings-input disabled-email"
                  placeholder="Enter your Email"
                />
              </Form.Item>
            </div>
          </div>

          {/* 💾 Save Button */}
          <div className="row mt-4">
            <div className="d-flex justify-content-end gap-2">
              <Button
                className="status-role-button"
                onClick={handleUpdateProfileData}
              >
                Save
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Account;
